<template>
  <div class="row">
    <div class="col-12">
      <div class="row row-cols-1 mt-5">
        <div class="alert alert-light" role="alert">
          <p class="m-1 fs-4">{{ mainTitle }} <small class="fs-6" v-html="subTitle"></small></p>
          <div class="alert alert-info" role="alert">本資料僅作為購票預算參考，建議依據現況及自身預算斟酌調整，其他日期區間或完整資料可參考 Just.崩潰 <router-link to="/AdvSearch">付費查詢</router-link></div>
        </div>
        <small class="mt-0">
          <!-- <h2><p>台灣虎航 24夏季第一波開賣各航點價格一覽表</p></h2> -->
          <ul>
            <li>24冬季班表第一波開放訂位時間 2024/6/24 尊榮虎、2024/6/25 ~ 6/26 全體會員</li>
            <li>2025農曆春節: 2025/1/25 ~ 2/2，數據提供範圍 2025/1/23 ~ 2/4</li>
            <li>價格皆為單程未稅 TWD，票種為 tigerlight</li>
            <li>不列入 2024/6/24 尊榮虎，僅針對全體會員開賣後各自算 7天，也就是</li>
            <ul>
              <li>2024/6/25 開賣航線: 統計時間 2024/6/25 10:00 ~ 7/2 23:59</li>
              <li>2024/6/26 開賣航線: 統計時間 2024/6/26 10:00 ~ 7/3 23:59</li>
            </ul>
          </ul>
        </small>
        <div class="d-flex align-items-center justify-content-center">
          <div class="">
            <iframe src="https://docs.google.com/spreadsheets/d/e/2PACX-1vQu8PKxN1E3-mU1mhEfncpmUlxdXcn5PhFfeaL8W_PulIw4E-wpbCPDR9xRq8o6X5wAR13nCCYTwwLc/pubhtml?widget=true&amp;headers=false" width="100%" height="100%" id="mainframe" marginheight="0" marginwidth="0" onload="this.width=screen.width;this.height=screen.height;" scrolling="yes"></iframe>
          </div>
        </div>
      </div>
      <template>
        <div class="ad-container">
          <Adsense data-ad-client="ca-pub-2965351057490665" data-ad-slot="5295990485" data-ad-format="auto" data-full-width-responsive="true"> </Adsense>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  export default {
    name: "StatW25CNY",
    data() {
      return {
        mainTitle: "(期間限定開放) 台灣虎航 24冬季班表第一波日韓航線各班次逐日均價（首7日平均）",
        subTitle: '<span class="fs-1 text-danger">2025 農曆春節</span> ',
      }
    },
    mounted: async function () {
      this.$confirm("資料已於 6/23 中午結束閱覽，如有需要請參考本站付費查詢項目，是否要前往了解？").then(() => {
        window.location.href = "https://www.facebook.com/just.bk.me/posts/967596972205081"
        // Cookies.set("disable_fareCal_hint", true, { expires: 7, secure: true })
      })
    },
  }
</script>
